import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as Global from 'src/app/global';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  Global = Global;
  loginForm: FormGroup;
  loginTab: any = 'coach';
  queryParams: any = null;
  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.queryParams = this.route.snapshot.queryParamMap.get('tab') || '';
    this.loginForm = formBuilder.group({
      email: [
        null,
        Validators.compose([Validators.required, Validators.email]),
      ],
      password: [null, Validators.compose([Validators.required])],
      rememberme: [null, Validators.compose([])],
    });

    // this.loginForm.patchValue({
    //   "email": "john.doe@yopmail.com",
    //   "password": "123456789",
    // })
  }

  ngOnInit(): void {
    this.onLoginTabChange(this.loginTab);
    // this.loginTab = this.queryParams;
  }

  submitLogin(event: any) {
    this.loginForm.markAllAsTouched();
    setTimeout(() => {
      Global.scrollToQuery('.form-control.is-invalid');
    }, 100);

    if (this.loginForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      if (this.loginTab == 'coach') {
        this.authService
          .coachLogin({
            email: this.loginForm.value.email ?? null,
            password: this.loginForm.value.password ?? null,
            user_type:'coach'

          })
          .subscribe(
            async (res) => {
              if (res.status == 'success') {
                this.authService.clearALLStorage();
                const data = {
                  token: res?.token ?? null,
                  coach: res?.coach ?? null,
                  is_subscribe: res?.coach.is_subscribe ?? null,
                };
                this.toastr.success(res.message);
                this.authService.coachSuccessLogin(
                  data,
                  this.loginForm.value.rememberme
                );
                this.router.navigate(['/sport']);
              } else if (res.status == 'val_error') {
                this.toastr.error(
                  Global.getValidationMessage(res.errors ?? [])
                );
              } else if (res.status == 'otp_sended') {
                this.toastr.success(res.message);
                this.router.navigate(['/signup'], {
                  queryParams: { tab: this.loginTab, otp: 'validation',email:this.loginForm.value.email },
                });
              } else {
                this.toastr.error(res.message);
              }

              event.target.classList.remove('btn-loading');
              event.target.disabled = false;
            },
            (err) => {
              event.target.classList.remove('btn-loading');
              event.target.disabled = false;
              if (err.status == 403) {
                this.toastr.error(err.error.message);
              } else {
                this.toastr.error(Global.getServerErrorMessage(err.error));
              }
            }
          );
      }
      else if (this.loginTab == 'athletic-director') {
        this.authService
          .coachLogin({
            email: this.loginForm.value.email ?? null,
            password: this.loginForm.value.password ?? null,
            user_type:'athletic_director'

          })
          .subscribe(
            async (res) => {
              if (res.status == 'success') {
                this.authService.clearALLStorage();
                const data = {
                  token: res?.token ?? null,
                  coach: res?.coach ?? null,
                  is_subscribe: res?.coach.is_subscribe ?? null,
                };
                this.toastr.success(res.message);
                this.authService.coachSuccessLogin(
                  data,
                  this.loginForm.value.rememberme
                );
              } else if (res.status == 'val_error') {
                this.toastr.error(
                  Global.getValidationMessage(res.errors ?? [])
                );
              } else if (res.status == 'otp_sended') {
                this.toastr.success(res.message);
                this.router.navigate(['/signup'], {
                  queryParams: { tab: this.loginTab, otp: 'validation',email:this.loginForm.value.email },
                });
              } else {
                this.toastr.error(res.message);
              }

              event.target.classList.remove('btn-loading');
              event.target.disabled = false;
            },
            (err) => {
              event.target.classList.remove('btn-loading');
              event.target.disabled = false;
              if (err.status == 403) {
                this.toastr.error(err.error.message);
              } else {
                this.toastr.error(Global.getServerErrorMessage(err.error));
              }
            }
          );
      }



      else {
                        this.authService.clearALLStorage();

        this.authService
          .schoolLogin({
            email: this.loginForm.value.email ?? null,
            password: this.loginForm.value.password ?? null,
          })
          .subscribe(
            async (res) => {
              if (res.status == 'success') {
                const data = {
                  token: res?.token ?? null,
                  school: res?.school ?? null,
                };
                this.toastr.success(res.message);
                this.authService.schoolSuccessLogin(
                  data,
                  this.loginForm.value.rememberme
                );
              } else if (res.status == 'val_error') {
                this.toastr.error(
                  Global.getValidationMessage(res.errors ?? [])
                );
              } else if (res.status == 'otp_sended') {
                this.toastr.success(res.message);
                this.router.navigate(['/signup'], {
                  queryParams: { tab: this.loginTab, otp: 'validation',email:this.loginForm.value.email },
                });
              }
              else {
                this.toastr.error(res.message);
              }

              event.target.classList.remove('btn-loading');
              event.target.disabled = false;
            },
            (err) => {
              event.target.classList.remove('btn-loading');
              event.target.disabled = false;
              if (err.status == 403) {
                this.toastr.error(err.error.message);
              } else {
                this.toastr.error(Global.getServerErrorMessage(err.error));
              }
            }
          );
      }
    }
  }
  onLoginTabChange(tab: any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tab: tab,
      },
    });
    this.queryParams = tab;
    switch (tab) {
      case 'coach':
        this.router.navigate(['login'], { queryParams: { tab: 'coach' } });
        break;
      case 'school':
        this.router.navigate(['login'], { queryParams: { tab: 'school' } });
        break;
      default:
        this.router.navigate(['login'], { queryParams: { tab: 'coach' } });
        break;
    }
  }
}
